import {Box, EyebrowText, SectionIntro} from '@primer/react-brand'
import type {Document} from '@contentful/rich-text-types'

import {renderWithNoMarks} from '../../../utils'

type PricingSectionIntroProps = {
  label?: string
  heading?: Document
  description?: Document
}

export function PricingSectionIntro({label, heading, description}: PricingSectionIntroProps) {
  return (
    <Box
      paddingBlockEnd={{
        narrow: 'spacious',
        regular: 64,
      }}
      paddingBlockStart={{
        narrow: 'spacious',
        regular: 64,
      }}
    >
      <SectionIntro align="center" fullWidth>
        {label && (
          <EyebrowText>
            <span style={{display: 'inline-flex', alignItems: 'center', gap: '0.25em'}}>
              {label}
              <span
                aria-hidden="true"
                style={{
                  width: 'var(--base-size-8)',
                  height: '1cap',
                  backgroundColor: 'var(--brand-color-success-fg)',
                }}
              />
            </span>
          </EyebrowText>
        )}
        {heading && <SectionIntro.Heading size="3">{renderWithNoMarks(heading)}</SectionIntro.Heading>}
        {description && <SectionIntro.Description>{renderWithNoMarks(description)}</SectionIntro.Description>}
      </SectionIntro>
    </Box>
  )
}
